module.exports = __webpack_public_path__ + "static/media/haiwairenyuanzhaopin.bd9f6e76.png";